import { defineStore } from 'pinia'

export const useTicketStore = defineStore('ticket', {
  state: () => ({
    ticketObj: {
      // 票数
      ticket: '',
      // 显示得票提示
      showTip: false,
      // 获得的票数
      sseTicketNum: '',
      // 获得票数的类型
      sseType: '',
      // 获得票数的到期时间
      sseTime: ''
    }
  }),
  getters: {
    getTicket: state => state.ticketObj.ticket,
    getSSETicketNum: state => state.ticketObj.sseTicketNum,
    getShowTip: state => state.ticketObj.showTip,
    getSSEType: state => state.ticketObj.sseType,
    getSSETime: state => state.ticketObj.sseTime
  },
  actions: {
    setTicket(number: string) {
      this.ticketObj.ticket = Number(number) < 0 ? '0' : number
    },
    clearTicket() {
      this.ticketObj.ticket = ''
    },
    setSSETicketNmu(number: string) {
      this.ticketObj.sseTicketNum = number
    },
    setShowTip(flag: boolean) {
      this.ticketObj.showTip = flag
    },
    setSSEType(type: string) {
      this.ticketObj.sseType = type
    },
    setSSETime(time: string) {
      this.ticketObj.sseTime = time
    },
    clearSSETicket() {
      this.ticketObj.sseTicketNum = ''
      this.ticketObj.showTip = false
      this.ticketObj.sseType = ''
      this.ticketObj.sseTime = ''
    }
  }
})
